export default [
    { title: 'Recipe directory', to: '#!' },
    { title: 'Help center', to: '#!' },
    { title: 'Privacy & terms', to: '#!' },
  ];
  